module.exports = __webpack_public_path__ + "static/img/pay3.b5e104b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/pay3.png
// module id = DOQQ
// module chunks = 1